import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { StylesEntity } from "../dto/style-carhartt.entity";
import { CommonResponseModel, StyleReq, TrimCards } from "@project-management-system/shared-models";
@Injectable()
export class StyleRepo extends Repository<StylesEntity> {
    constructor(@InjectRepository(StylesEntity) private styleRepo: Repository<StylesEntity>
    ) {
        super(styleRepo.target, styleRepo.manager, styleRepo.queryRunner);
    }

    async getAllCarharttMeasurementData(): Promise<TrimCards[]> {
        let query = (`      
                    SELECT s.id,s.style AS styleData,s.season AS seasonData,s.tech_pack AS techPack,s.submit_date AS submitDate,s.created_at AS createdAt,s.drop_down AS dropDown ,s.status,s.pdf_file_path AS filePath,s.pdf_file_name AS fileName,s.pdf_original_name AS originalName 
                    FROM styles_entity s
                    WHERE s.status ='OPEN'
                    `)
        const result = await this.query(query);
        return result.map((rec) => {
            const combinedProductPlusColor = {
                combinedFabricColorHeaders: [],
                combinedLabelColorHeaders: [],
                combinedPackingColorHeaders: []
            }
            return new TrimCards(rec.id, rec.styleData, rec.seasonData, rec.submitDate, rec.createdAt, rec.dropDown, rec.techPack, rec.filePath, rec.fileName, rec.originalName, rec.status, combinedProductPlusColor)

        }


        )
    };
}

